import { useDispatch, useSelector } from 'react-redux';
import {
  openSettingsDrawer,
  closeSettingsDrawer,
  toggleSettingsDrawer,
  setActiveSettingsTab,
  openSettingsWithTab,
} from '../reducers/uiSlice';

export const useSettingsDrawer = () => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.ui.activeSettingsTab);
  const isOpen = useSelector((state) => state.ui.settingsDrawerOpen);

  return {
    activeTab,
    isOpen,
    openDrawer: () => dispatch(openSettingsDrawer()),
    closeDrawer: () => dispatch(closeSettingsDrawer()),
    toggleDrawer: () => dispatch(toggleSettingsDrawer()),
    setActiveTab: (tab) => dispatch(setActiveSettingsTab(tab)),
    openDrawerWithTab: (tab) => dispatch(openSettingsWithTab(tab)),
  };
};
